<template>
  <a-modal v-if="modal" @close="$emit('close')">
    <h2 slot="header">
      Sigue estas instrucciones para optimizar tu verificación facial
    </h2>
    <div slot="body">
      <div class="intructions">
        <a-icon name="ic-help-toc-pos" />
        <p>
          Sitúa la cámara de tu dispositivo a la altura de tu rostro
        </p>
      </div>
      <div class="intructions">
        <a-icon name="ic-help-toc-blight" />
        <p>
          Evita ubicarte a contraluz
        </p>
      </div>
      <div class="intructions">
        <a-icon name="ic-help-toc-background" />
        <p>
          Evita fondos similares al color de tu rostro
        </p>
      </div>
      <div class="intructions">
        <a-icon name="ic-help-toc-hat" />
        <p>
          Evita elementos extra, como gorros o lentes
        </p>
      </div>
    </div>
    <div slot="footer"></div>
  </a-modal>
</template>

<script>
import AModal from '@/components/ui/AModal';
import AIcon from '@/components/ui/AIcon';

export default {
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    AModal,
    AIcon,
  },
};
</script>
